import { Box, ListItemButton, ListItemText, Tooltip } from '@mui/material'
import ListItem from '@mui/material/ListItem'
import { useTranslation } from 'react-i18next'

import { NavItem } from '@/common/components'
import {
  listItemButtonStyles,
  listItemTextStyles,
  SidebarBadge,
} from '@/common/components/SideBarLegacy/SidebarComponents/NavBar/NavBarStylesLegacy'
import { ITenantState } from '@/features/auth/types'
import { useLocation, useNavigate } from '@/hooks'

interface INavBarMenuItemProps {
  isNavBarOpen: boolean
  path: string
  isTenantSearch?: boolean
  activeTenant?: ITenantState
  menu: { icon: string; label: string; badgeCount?: number; badgeTooltip?: string }
  handleTenantItemClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  onNavigate?: () => void
}
const NavBarMenuItem = ({
  isNavBarOpen,
  isTenantSearch = false,
  path,
  menu,
  handleTenantItemClick,
  activeTenant = undefined,
  onNavigate,
}: INavBarMenuItemProps) => {
  const { t } = useTranslation('general')
  const navigate = useNavigate()
  const location = useLocation()

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isTenantSearch && handleTenantItemClick) {
      handleTenantItemClick(event)
    } else {
      navigate(event)
      if (onNavigate) {
        onNavigate()
      }
    }
  }

  const showBadge = !!menu.badgeCount && menu.badgeCount > 0

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        sx={listItemButtonStyles(isNavBarOpen, isTenantSearch)}
        href={path}
        selected={isTenantSearch ? !!activeTenant?.id : location.pathname.includes(path)}
        onClick={handleClick}>
        {menu?.icon &&
          !isTenantSearch &&
          (showBadge && !isNavBarOpen ? (
            <Tooltip title={menu.badgeTooltip || ''} placement="right" arrow>
              <SidebarBadge overlap="circular" anchorOrigin={{ vertical: 'top', horizontal: 'right' }} badgeContent="">
                <Box sx={{ display: 'inline-flex' }}>
                  <NavItem isOpen={isNavBarOpen} icon={menu?.icon} isSidebarOpen={isNavBarOpen} />
                </Box>
              </SidebarBadge>
            </Tooltip>
          ) : (
            <NavItem isOpen={isNavBarOpen} icon={menu?.icon} isSidebarOpen={isNavBarOpen} />
          ))}

        <ListItemText
          primary={isTenantSearch ? activeTenant?.name || 'No Tenant Selected' : t(menu?.label)}
          sx={listItemTextStyles(isNavBarOpen)}
        />
        {isNavBarOpen && showBadge && !isTenantSearch && (
          <Tooltip title={menu.badgeTooltip || ''} placement="right" arrow>
            <Box sx={{ ml: 1 }}>
              <SidebarBadge badgeContent="" />
            </Box>
          </Tooltip>
        )}

        {isTenantSearch && (
          <NavItem isOpen={isNavBarOpen} icon="SearchTenantIcon" isTenantSearch={true} isSidebarOpen={isNavBarOpen} />
        )}
      </ListItemButton>
    </ListItem>
  )
}

export default NavBarMenuItem
